import { Components, Theme } from '@mui/material';

export const avatarConfigs: Components<Theme>['MuiAvatar'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.primaries[400],
      fontSize: theme.typography.body2Bold.fontSize,
      fontWeight: theme.typography.body2Bold.fontWeight,
      textTransform: 'uppercase',
    }),
  },
};
